<div
  *ngIf="showAIButton && modalHasOpened"
  class="modal-container"
  [class.close]="!isChatModalOpen"
>
  <!-- <div class="modal-overlay" (click)="onCloseChat()"></div> -->
  <app-chat (close)="onCloseChat()"></app-chat>
</div>

<div class="main-content-area">
  <ng-container *ngIf="showHeader">
    <app-header></app-header>
    <app-navigation (openChat)="onOpenChat()"></app-navigation>
  </ng-container>

  <main [class.modal-open]="isChatModalOpen">
    <router-outlet></router-outlet>
  </main>
</div>
